import React from 'react';
import { Address, Message } from '@multiversx/sdk-core/out';
import { getAccountProvider } from 'helpers';
import { useGetAccount } from 'hooks';
import { SignFailure, SignMessageWrapper, SignSuccess } from './components';

export const SignMessage = () => {
  const { address } = useGetAccount();
  const [message, setMessage] = React.useState('');
  const [status, setStatus] = React.useState<'idle' | 'success' | 'error'>(
    'idle'
  );
  const [signature, setSignature] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState<string>();

  const handleReset = () => {
    setStatus('idle');
    setMessage('');
    setSignature('');
    setErrorMessage(undefined);
  };

  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();

    try {
      const provider = getAccountProvider();
      const signedMessage = await provider.signMessage(
        new Message({
          address: new Address(address),
          data: new Uint8Array(Buffer.from(message))
        })
      );

      if (!signedMessage?.signature) {
        setStatus('error');
        return;
      }

      setSignature(Buffer.from(signedMessage.signature).toString('hex'));
      setStatus('success');
    } catch (err) {
      setErrorMessage((err as Error).message);
      setStatus('error');
    }
  };

  if (status === 'error') {
    return (
      <SignMessageWrapper>
        <SignFailure errorMessage={errorMessage} onReset={handleReset} />
      </SignMessageWrapper>
    );
  }

  if (status === 'success') {
    return (
      <SignMessageWrapper>
        <SignSuccess signature={signature} onReset={handleReset} />
      </SignMessageWrapper>
    );
  }

  return (
    <SignMessageWrapper>
      <div className='sign-message'>
        <h1 className='card-title'>Sign Message</h1>
        <div className='card-body p-1 d-flex flex-column'>
          <textarea
            className='form-control my-3'
            value={message}
            onChange={(event) => setMessage(event.currentTarget.value)}
          />
          <button
            className='btn btn-primary'
            disabled={!message.trim()}
            onClick={handleSubmit}
          >
            Sign
          </button>
        </div>
      </div>
    </SignMessageWrapper>
  );
};
